import { createFileRoute } from '@tanstack/react-router';
import ErrorPage from '../Components/ErrorPage';

export const Route = createFileRoute('/forbidden')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ErrorPage
      code="403"
      title="Access Denied"
      message="You do not have permission to view this page. If you believe this is a mistake, please contact your administrator."
    />
  );
}
